var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNlUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FFCB65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3523 11.8182H35.5227V29.1534C35.5227 30.9432 35.1009 32.5412 34.2571 33.9474C33.4219 35.3452 32.2415 36.4489 30.7159 37.2585C29.1903 38.0597 27.4006 38.4602 25.3466 38.4602C23.2926 38.4602 21.5028 38.0597 19.9773 37.2585C18.4517 36.4489 17.267 35.3452 16.4233 33.9474C15.5881 32.5412 15.1705 30.9432 15.1705 29.1534V11.8182H18.3409V28.8977C18.3409 30.1761 18.6222 31.3139 19.1847 32.3111C19.7472 33.2997 20.5483 34.0795 21.5881 34.6506C22.6364 35.2131 23.8892 35.4943 25.3466 35.4943C26.804 35.4943 28.0568 35.2131 29.1051 34.6506C30.1534 34.0795 30.9545 33.2997 31.5085 32.3111C32.071 31.3139 32.3523 30.1761 32.3523 28.8977V11.8182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlUser);
export default __webpack_public_path__ + "static/media/NL_User.ce49bf39cc1186d1f547c63086eb1910.svg";
export { ForwardRef as ReactComponent };